<template>
	<div :class="['step-four', {'mb-5': ! isActive}]">
		<stepHeader msg="Kundinformation" :currentStep="4" :maxStep="4" :useSubtitle="! isActive" :useBackgroundColor="! isActive || activeStep < 4" />
		<customerInfo
			v-if="! showKcoIframe"
			:activeStep="activeStep"
			:isActive="isActive"
			:customerInfoData.sync="customerInfoData"
			:confirmedEmail.sync="confirmedEmail"
			:isStoreReservation="isStoreReservation"
			:isCorporateCustomer="isCorporateCustomer"
			:selectedPaymentMethodId="selectedPaymentMethodId"
			:selectedShippingMethodId="selectedShippingMethodId"
			:boughtInsurance="boughtInsurance"
			@updateInvalidArray="invalidArray = $event"
		/>
		<div
			v-else-if="showKcoIframe && activeStep > 3"
			ref="kcoIframe"
			class="kco-html"
		/>
		<div v-if="activeStep > 3" class="checkout-confirmation-wrap">
			<div class="col-xs-12 text-center" v-if="isActive && ! showKcoIframe">
				<div v-if="selectedPaymentMethodId === 22/*Webhallen delbetalning*/" class="alert alert-info mt-5 small">
					<template v-if="! isLoggedIn">
						<p>Som medlem på Webhallen kan du se dina aktuella delbetalningar, din beställningshistorik och spara kvitton på ett och samma ställe.</p>
						<a @click="login">Logga in</a> / <a @click="register">Skapa konto</a>
					</template>
					<strong>Kan endast levereras till beställarens bokföringsadress eller hämtas i butik mot uppvisande av legitimation.</strong>
					<p>Fakturan skapas endast om ordern hämtas/skickas.</p>
					<p>Se <router-link :to="$router.route({
						name: 'info',
						params: { id: 13, },
					})">Köpinfo</router-link> för mer information. Se <a @click="sekkiAgrement">SEKKI </a></p>
				</div>
				<div class="checkout-amount">
					{{ pendingAmountFormatted }}
				</div>
				<div v-if="cartSumInsurances > 0" class="sub-title">
					(varav försäkringar {{ cartSumInsurancesFormatted }})
				</div>
				<div class="mb-5">
					Totalbelopp inkl moms
				</div>
				<div v-if="orderError" class="alert alert-danger mt-5">
					<span class="glyphicon glyphicon-warning-sign" />
					{{ orderError }}
				</div>
				<div class="center-block confirm-checkout">
					<text-button
						v-if="! orderIsProcessing"
						class="confirm-order-btn"
						text="Bekräfta beställning"
						size="large"
						:disabled="! checkoutValid || ! step4Ready"
						width="stretch"
						@click="confirmOrder"
					/>
					<template v-else>
						<div class="checkout-loading">
							<loading-spinner />
							Ordern behandlas...
						</div>
					</template>
				</div>
			</div>
			<div class="sub-title">
				{{ termsText }}
				<a-link :to="conditionsPath" target="_blank">köpvillkoren</a-link>
				hos Webhallen Sverige AB
				<span v-if="boughtInsurance">, samt att jag har tagit del av
					<a href="https://www.carepack.nu/globalassets/documents/terms/webhallen_care_pack_broschyr-2023.pdf" target="_blank">informationsbroschyren</a>
					och
					<a href="https://www.carepack.nu/globalassets/documents/terms/ipid-carepack-0229-3-20230501.pdf" target="_blank">IPID (försäkringsfaktablad)</a>
					för försäkring jag har valt till min(a) produkt(er).
				</span>
				<span v-else>.</span>
			</div>
		</div>
	</div>
</template>

<script>
import { debounce } from 'lodash';
import waja from 'waja';
import alert from 'alert';
import bus from 'eventbus';
import download from 'downloadjs';
import { formatPrice, convertToCdnUrl } from 'utils';
import stepHeader from './step-header';
import customerInfo from './customer-info';
import { mapGetters } from 'vuex';
import { getCartSum, getInsuranceSum } from 'utils/cart';
import * as bambora from '@bambora/checkout-sdk-web';
import localSessionStorage from 'localSessionStorage';
import { isDesktop } from 'mediaQuery';

export default {
	components: {
		stepHeader,
		customerInfo,
	},
	props: {
		isActive: {
			type: Boolean,
			required: false,
		},
		selectedPaymentMethodId: {
			type: Number,
			required:false,
			default: 0,
		},
		selectedPaymentOption: {
			type: Object,
			required: false,
			default: () => {},
		},
		selectedShippingMethodId: {
			type: Number,
			required:false,
			default: 0,
		},
		selectedShippingOption: {
			type: Object,
			required:false,
			default: () => {},
		},
		selectedStoreId: {
			type: Number,
			required:false,
			default: 0,
		},
		isCorporateCustomer: {
			type: Boolean,
			required: true,
		},
		isStoreReservation: {
			type: Boolean,
			required: false,
			default: false,
		},
		cart: {
			type: Object,
			required: true,
		},
		vouchers: {
			type: Array,
			defult: null,
		},
		activeStep: {
			type: Number,
		},
		paymentLink: {
			type: String,
			default: null,
		},
		partialDelivery: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			ref: '',
			reloadingKco: false,
			confirmedEmail: '',
			orderIsProcessing: false,
			isAwaitingBankid: false,
			bankIdIsConfirmed: false,
			pendingAmount: 0,
			invalidArray: [],
			orderError: null,
			selectedPerk: null,
			availablePerk: null,
			missingStep: null,
			customerInfoData: {
				ssn: '',
				first_name: '',
				last_name: '',
				email: '',
				phone: '',
				zip_code: '',
				city: '',
				street_address: '',
				delivery_corporate_name: '',
				delivery_email: '',
				delivery_phone: '',
				delivery_zip_code: '',
				delivery_city: '',
				delivery_street_address: '',
				delivery_attention: '',
			},
		};
	},
	mounted () {
		bus.$on('checkout:setperk', this.setPerk);
		bus.$on('checkout:disablePerk', this.setDisablePerk);
		bus.$on('total-amount', this.setPendingAmount);
		bus.$emit('reloadKlarna', this.reloadKlarna);
		bus.$emit('update:reloadingKco', this.setReloadingKco);
	},
	beforeDestroy () {
		bus.$off('checkout:setperk', this.setPerk);
		bus.$off('checkout:disablePerk', this.setDisablePerk);
		bus.$off('bankid.confirmed', this.bankIdConfirmed);
		bus.$off('bankid.cancelled', this.authenticationCancelled);
		bus.$off('bankid.closed', this.authenticationCancelled);
		bus.$off('order-details.attention', this.updateAttention);
		bus.$off('total-amount', this.setPendingAmount);
	},
	methods: {
		convertToCdnUrl,
		setPerk (perk) {
			this.availablePerk = perk;
		},
		// Ensuring perk is not used if unavailable for shipping method
		setDisablePerk (val) {
			if(val) {
				this.selectedPerk = null;
			} else {
				this.selectedPerk = this.availablePerk;
			}
		},
		setReloadingKco (val) {
			this.reloadingKco = val;
		},
		setPendingAmount (amount) {
			this.pendingAmount = amount;
		},
		bankIdConfirmed () {
			if (this.isAwaitingBankid) { // För att förhindra att dubbla ordrar läggs
				this.isAwaitingBankid = false;
				this.orderIsProcessing = false;
				this.bankIdIsConfirmed = true;
				this.confirmOrder();
			}
		},
		authenticationCancelled () {
			alert('Du måste signera köpet med bankid! Vänligen försök igen.');
			this.isAwaitingBankid = false;
			this.orderIsProcessing = false;
			if (this.ref) {
				this.ref = '';
			}
		},
		getSignature () {
			const orderInfo = {
				customerInfo: this.customerInfoData,
				paymentOption: this.selectedPaymentOption.code,
				amount: this.pendingAmount,
			};

			waja.post('bankid/reference').data({orderInfo})
				.on('success', res => {
					if (res.data.orderRef) {
						this.ref = res.data.orderRef;
						if (! this.ref) {
							this.orderIsProcessing = false;
							alert('Kunde inte begära signering. Vänligen vänta några minuter och testa igen. Om felet kvarstår, kontakta kundtjänst.');
							return;
						}

						this.isAwaitingBankid = true;
						bus.$off('bankid.confirmed', this.bankIdConfirmed);
						bus.$off('bankid.cancelled', this.authenticationCancelled);
						bus.$off('bankid.closed', this.authenticationCancelled);
						bus.$on('bankid.confirmed', this.bankIdConfirmed);
						bus.$on('bankid.cancelled', this.authenticationCancelled);
						bus.$on('bankid.closed', this.authenticationCancelled);

						bus.$emit('modal.component', 'bankid-modal'); // öppna bankid-popupen
						this.$nextTick(() => {
							bus.$emit('bankid.updateReference', this.ref);
						});
					}
				}).on('error', err => {
					if (err.status == 500) {
						alert('Fel format på personnummer, vänligen använd YYmmddXXXX');
					} else {
						alert('Något gick fel vid hämtning av BankID.');
					}
				}).go();
		},
		confirmOrder () {
			if (this.orderIsProcessing) {
				alert('Vänligen vänta');
				return;
			}

			if (this.selectedPaymentMethodId === 22) {
				this.getSignature();
				if (this.bankIdIsConfirmed !== true) {
					return;
				}
			}
			this.refreshCart();

			const giftCards = [];
			let useStoreCredit = false;
			const discountCodes = [];
			for (const voucher of this.vouchers) {
				if (voucher.type === 'giftCard') {
					giftCards.push(voucher.code);
				} else if (voucher.type === 'storeCredit') {
					useStoreCredit = true;
				} else if (voucher.type === 'discountCode') {
					discountCodes.push(voucher.code);
				}
			}

			// Extra fraktalternativ, ex postombud eller val av leveransdag
			let shippingOptionCode = null;
			let shippingOption = null;
			if (this.selectedShippingOption) {
				shippingOption = {
					value: this.selectedShippingOption.value,
					type: this.selectedShippingOption.type,
				};
				// These are not needed in the shippingOptionCode
				delete this.selectedShippingOption.value
				delete this.selectedShippingOption.type

				shippingOptionCode = JSON.stringify(this.selectedShippingOption);
			}

			const order = {
				currency: this.cart.currency,
				customerInfo: this.customerInfoData,
				// attention: this.attention,
				paymentMethod: this.selectedPaymentMethodId,
				paymentOption: this.selectedPaymentOption ? this.selectedPaymentOption.code : null,
				isCorporateCustomer: this.isCorporateCustomer,
				shippingMethod: this.isStoreReservation ? 4 : this.selectedShippingMethodId === 100 ? 1 : this.selectedShippingMethodId,
				shippingServiceCode: localSessionStorage.get('checkout:selectedShippingServiceCode'),
				shippingOptionCode,
				shippingOption,
				shippingSiteId: localSessionStorage.get('checkout:shippingSiteId'),
				rows: this.cart.rows.map(row => {
					const orderRow = {
						productId: row.product.id,
						unitPrice: row.unitPrice,
						quantity: row.quantity,
						pass: row.pass,
						extraData: row.extraData,
						isSentFromStore: row.product.stock.isSentFromStore
					};

					// Check if the product has an insurance that can be purchased.
					if (row.insurance) {
						orderRow.insurance = {
							productId: row.insurance.id,
							unitPrice: row.insurance.price,
						};

					}

					// Check if the insurance was bought.
					if (orderRow.insurance && row.extraData && row.extraData.insured) {
						orderRow.insurance.insured = true;
					}

					return orderRow;
				}),
				perk: this.selectedPerk ? this.selectedPerk.id : null,
				giftCards,
				useStoreCredit,
				discountCodes: discountCodes,
				partialDelivery: this.partialDelivery,
			};
			if (this.paymentLink) {
				order.paymentLink = this.paymentLink;
			} else {
				order.cartId = this.cart.id;
			}

			if (this.isStoreReservation) {
				order.storeId = this.selectedStoreId;
			}

			this.orderIsProcessing = true;

			this.savedSelectedPaymentMethodId = this.selectedPaymentMethodId;

			waja.post('order')
				.data({
					order,
					touchpoint: isDesktop() ? 'DESKTOP' : 'MOBILE',
					analyticsClientId: this.analyticsClientId,
				})
				.on('success', res => {
					let url;
					if (this.savedSelectedPaymentMethodId === 32) {
						const token = res.data.token;
						const eventHandlerMap = {};

						eventHandlerMap[bambora.Event.Close] = [function(payload) {
							window.location = payload.acceptUrl;
						}];

						eventHandlerMap[bambora.Event.Cancel] = [function(payload) {
							window.location = payload.declineUrl;
						}];

						const checkout = new bambora.ModalCheckout(token, { eventHandlerMap: eventHandlerMap });;

						checkout.show();
					} else if (res.data.paymentUrl) {
						url = res.data.paymentUrl;
						if (res.data.paymentUrl[0] === '/' && res.data.paymentUrl[1] !== '/') { // länken är intern
							this.$router.push(url, () => {
								this.$store.dispatch('cart/wasDestroyed');
							});
						} else { // extern länk
							window.location = res.data.paymentUrl;
						}
					} else {
						url = '/checkout-complete/' + res.data.orderId + '?email=' + this.customerInfoData.email;
						if (res.data.secret) {
							url += '&secret=' + res.data.secret;
						}
						if (this.customerInfoData.phone) {
							url += '&phone=' + this.customerInfoData.phone;
						}
						this.$router.push(url, () => {
							this.$store.dispatch('cart/wasDestroyed');
						});
					}
				})
				.on('error', res => {
					if (res.status === 400) {
						this.orderIsProcessing = false;
						res.json().then(json => {
							// @TODO vi kanske ska ha en map med olika nycklar och fraser för dem ist för fula ifar
							if (json.errors && (json.errors['order.customerInfo.street_address'] || json.errors['order.customerInfo.city'])) {
								alert('Adressen du matat in är ogiltig! Vänligen korrigera felet och försök igen.');
							} else if (json.errors && json.errors['order.customerInfo.zip_code']) {
								alert('Postnumret du matat in är ogiltigt! Vänligen korrigera felet och försök igen.');
							} else if (json.errors && json.errors['order.customerInfo.email']) {
								alert('E-postadressen du matat in är ogiltig! Vänligen korrigera felet och försök igen.');
							} else if (json.errors && json.errors['order.customerInfo.phone']) {
								alert('Telefonnumret du matat in är ogiltigt! Vänligen korrigera felet och försök igen.');
							} else if (json.errors && (json.errors['order.customerInfo.first_name'] || json.errors['order.customerInfo.last_name'])) {
								alert('Du har inte matat in namn och/eller efternamn! Vänligen korrigera felet och försök igen.');
							} else {
								alert('Du har matat in ogiltiga uppgifter!');
							}
						});
					} else if (res.status === 403) {
						if (res.headers.has('Bankid-reference')) { // @TODO hantera internt i waja
							this.ref = res.headers.get('Bankid-reference');
							if (! this.ref) {
								this.orderIsProcessing = false;
								alert('Kunde inte begära signering. Vänligen vänta några minuter och testa igen. Om felet kvarstår, kontakta kundtjänst.');
								return;
							}

							this.isAwaitingBankid = true;
							bus.$off('bankid.confirmed', this.bankIdConfirmed);
							bus.$off('bankid.cancelled', this.authenticationCancelled);
							bus.$off('bankid.closed', this.authenticationCancelled);
							bus.$on('bankid.confirmed', this.bankIdConfirmed);
							bus.$on('bankid.cancelled', this.authenticationCancelled);
							bus.$on('bankid.closed', this.authenticationCancelled);

							bus.$emit('modal.component', 'bankid-modal'); // öppna bankid-popupen
							this.$nextTick(() => {
								bus.$emit('bankid.updateReference', this.ref);
							});
						} else {
							this.orderIsProcessing = false;
							res.json().then(json => {
								this.orderError = json.errorMessage;
								if (json.noRetry) { // ingen mening med att försöka igen med samma betalsätt
									this.selectedPaymentMethod = null;
								}
							});
						}
					} else {
						this.orderIsProcessing = false;
						alert('Något gick fel. Vänligen kontrollera att alla fält är korrekt ifyllda och försök igen.');
					}
				}).go();
		},
		_reloadKCO () { // anropas genom debounce
			this.reloadingKco = true;
			Vue.nextTick(() => {
				this.reloadingKco = false;
			});
		},
		login () {
			bus.$emit('header.show');
			bus.$emit('open:login');
		},
		register () {
			bus.$emit('header.show');
			bus.$emit('open:register');
		},
		sekkiAgrement () {
			waja.request('GET', 'financing-info/sekki-pdf/' + this.pendingAmount, null, null, false)
				.data({
					selectedPaymentOption: this.selectedPaymentOption.code,
				})
				.on('success', res => {
					res.blob().then(blob => download(blob, 'Sekki.pdf', 'pdf'));
				})
				.on('error', res => {
					alert('Något gick fel vid nedladdning av Sekki-filen');
				}).go();
		},
		refreshCart () {
			this.$store.dispatch('cart/refresh');
		},
		_reloadKlarna () { // anropas genom debounce
			this.reloadingKco = true;
			Vue.nextTick(() => {
				this.reloadingKco = false;
			});
		},
		kcoCodeSnippet (resolve, reject) {
			(async () => {
				const response = await fetch(this.kcoIframeUrl);
				switch (response.status) {
					// status "OK"
					case 200:
						const template = await response.text();
						resolve(template);
						break;
					// status "Not Found"
					case 404:
						reject('Not Found');
						break;
				}
			})();
		},
		renderKco (kcoCode) {
			const checkoutContainer = this.$refs.kcoIframe;
			checkoutContainer.innerHTML = kcoCode;
			const scriptsTags = checkoutContainer.getElementsByTagName('script')
			// This is necessary otherwise the scripts tags are not going to be evaluated
			for (let i = 0; i < scriptsTags.length; i++) {
				const parentNode = scriptsTags[i].parentNode;
				const newScriptTag = document.createElement('script');
				newScriptTag.type = 'text/javascript';
				newScriptTag.text = scriptsTags[i].text;
				parentNode.removeChild(scriptsTags[i]);
				parentNode.appendChild(newScriptTag);
			}
		},
		updateKcoPromise () {
			(new Promise(this.kcoCodeSnippet))
				.then(this.renderKco)
				.catch((reason) => {
					console.log('reason',reason);
				});
		},
	},
	computed: {
		showKcoIframe () {
			return this.selectedPaymentMethodId === 20 && ! this.reloadingKco && ! this.isCorporateCustomer; // klarna checkout
		},
		kcoIframeUrl () {
			if (this.cart.rows.length === 0) {
			    return;
			}
			const shippingMethodId = this.isStoreReservation ? 4 : this.selectedShippingMethodId === 100 ? 1 : this.selectedShippingMethodId === 101 ? 3 : this.selectedShippingMethodId;
			let url = '/api/checkout/kco?shippingMethod=' + shippingMethodId + '&storeId=' + this.selectedStoreId;
			if (localSessionStorage.get('checkout:shippingSiteId')) {
				url += '&shippingSiteId=' + localSessionStorage.get('checkout:shippingSiteId');
			}
			if (this.selectedPerk) {
				url += '&perk=' + this.selectedPerk.id;
			}
			if (this.paymentLink) {
				url += '&paymentLink=' + this.paymentLink;
			}
			if (this.vouchers.length) {
				const giftCards = [];
				const discountCodes = [];
				for (const voucher of this.vouchers) {
					if (voucher.type === 'giftCard') {
						giftCards.push(voucher.code);
					} else if (voucher.type === 'storeCredit') {
						url += '&useStoreCredit=1';
					} else if (voucher.type === 'discountCode') {
						 discountCodes.push(voucher.code);
					}
				}
				url += '&giftCards=' + encodeURIComponent(giftCards.join(','));
				url += '&discountCodes=' + encodeURIComponent(discountCodes.join(','));
			}
			if (this.selectedShippingOption) {
				url += '&shippingOptionType=' + encodeURIComponent(this.selectedShippingOption.type) + '&shippingOptionValue=' + encodeURIComponent(this.selectedShippingOption.value);
			}
			if (this.cart) {
				url += '&cartId=' + encodeURIComponent(this.cart.id) + '&lastUpdate=' + encodeURIComponent(this.cart.lastUpdate);
			}

			url += '&partialDelivery=' + encodeURIComponent(this.partialDelivery);

			if (this.selectedShippingOption) {
				url += '&shippingOptionCode=' + encodeURIComponent(JSON.stringify(this.selectedShippingOption));
			}

			url += '&shippingServiceCode=' + encodeURIComponent(localSessionStorage.get('checkout:selectedShippingServiceCode'));

			return url;
		},
		reloadKCO () {
			return debounce(this._reloadKCO.bind(this), 200);
		},
		checkoutValid () { // Är checkout redo för bekräftelse? true / false
			if (! this.selectedPaymentMethodId) {
				this.missingStep = 3;
				return false;
				// selectedPaymentMethodId 24 = presentkord, 27 = tillgodo
			} else if (this.pendingAmount !== 0 && (this.selectedPaymentMethodId === 24 || this.selectedPaymentMethodId === 27)) {
				this.missingStep = 3;
				return false;
			} else {
				this.missingStep = null;
				return this.invalidArray.length === 0;
			}
		},
		step4Ready () {
			return (
				this.isStoreReservation === true &&
				this.selectedStoreId !== null
			) || (
				this.isStoreReservation === false &&
				this.selectedShippingMethodId !== null
			);
		},
		boughtInsurance () {
			return this.cart.rows.some(row => row.extraData && row.extraData.insured);
		},
		conditionsPath () {
			return this.$router.route({
				name: 'info',
				params: {
					id: 8,
					name: 'Köpvillkor',
				},
			});
		},
		cartSumInsurancesFormatted () {
			return formatPrice(this.cartSumInsurances, this.cart.currency);
		},
		cartSumInsurances () {
			return getInsuranceSum(this.cart);
		},
		cartSum () {
			return getCartSum(this.cart);
		},
		reloadKlarna () {
			return debounce(this._reloadKlarna.bind(this), 200);
		},
		pendingAmountFormatted () {
			return formatPrice(this.pendingAmount, 'SEK');
		},
		termsText () {
			if (this.selectedPaymentMethodId === 22 /*Webhallen delbetalning*/) {
				return 'Genom att bekräfta beställningen accepterar jag betalningsansvar och godkänner ';
			} else {
				return 'Genom att bekräfta beställningen godkänner jag ';
			}
		},
		...mapGetters({
			/*shippingDiscount: 'user/shippingDiscount',*/
			isLoggedIn: 'user/isLoggedIn',
			rankLevel: 'user/rankLevel',
		}),
	},
	watch: {
		missingStep (to) {
			if (to) {
				this.$emit('missingStep',to);
			}
		},
		kcoIframeUrl () {
			if (this.showKcoIframe && this.isActive) {
				this.updateKcoPromise();
			}
		},
		isActive (to) {
			if (to && this.showKcoIframe) {
				this.updateKcoPromise();
			}
		},
	},
};
</script>
